import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { Carousel } from '@sbt-web/carousel';
import { useMediaQuery, useViewport } from '@sbt-web/hooks';
import type { AdItem } from '@sbt-web/network/types';
import { DeviceWidth } from '@sbt-web/ui';
import type { RootState } from '@/reducers/index';
import { getRankFor } from '@/shared/helpers/Rank';
import { getRankedUrnForGeoboost } from '@/shared/helpers/Rank/store';
import { useTrackImpression } from '@/tools/tracking/useTrackImpression';
import { isInterstitialEnabled } from '@/shared/adv/interstitial';
import { Card } from './card';
import { trackView, trackImpression } from './tracking';
/* eslint-disable import/order */
import '@sbt-web/carousel/style';
import styles from './index.module.scss';
import cardStyles from './card/index.module.scss';
type StateProps = {
  rank?: number;
  searchId: string;
};
type OwnProps = {
  items: AdItem[];
};
type Props = OwnProps & StateProps;
const Geoboost = t0 => {
  const $ = _c(27);
  const {
    items,
    rank,
    searchId
  } = t0;
  const showCarouselNavigation = useMediaQuery(`(min-width: ${DeviceWidth.desktop.min})`);
  const {
    isMobile
  } = useViewport();
  const countCssClass = styles[`count--${items.length}`];
  const componentRef = useRef(null);
  let t1;
  if ($[0] !== items || $[1] !== rank) {
    t1 = {
      enabled: true,
      track: () => {
        trackImpression(items, rank ?? -1);
      }
    };
    $[0] = items;
    $[1] = rank;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const setComponentRef = useTrackImpression(t1);
  const getInterstitialAttrs = _temp;
  let t2;
  let t3;
  if ($[3] !== items || $[4] !== rank) {
    t2 = () => {
      trackView(items, rank ?? -1);
    };
    t3 = [items, rank];
    $[3] = items;
    $[4] = rank;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[7] !== setComponentRef) {
    t4 = () => {
      if (componentRef?.current) {
        setComponentRef(componentRef.current);
      }
    };
    t5 = [setComponentRef, componentRef];
    $[7] = setComponentRef;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== isMobile || $[11] !== items || $[12] !== searchId) {
    let t7;
    if ($[14] !== isMobile || $[15] !== items.length || $[16] !== searchId) {
      t7 = (ad_0, index) => <li key={ad_0.urn} {...getInterstitialAttrs(ad_0)}><Card className={cn(styles.card, cardStyles[`card-${items.length > 1 ? "mini" : "landscape"}-on-msite`], cardStyles[`card-${items.length > 4 ? "mini" : "landscape"}-on-desktop`])} ad={ad_0} rank={index} searchId={searchId} isMobile={isMobile} /></li>;
      $[14] = isMobile;
      $[15] = items.length;
      $[16] = searchId;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t6 = items.map(t7);
    $[10] = isMobile;
    $[11] = items;
    $[12] = searchId;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const cards = t6;
  const t7 = `${styles.container} ${countCssClass}`;
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h6 className={`${styles.title} headline-6`}>Scelti per te</h6>;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== cards || $[20] !== isMobile || $[21] !== items.length || $[22] !== showCarouselNavigation) {
    t9 = items.length < 3 && !isMobile ? <ul className={`${styles["raw-items"]}`}>{cards}</ul> : <Carousel cssClass={`${styles.carousel} slider-nav-round`} labelArrows={{
      right: "Avanti",
      left: "Indietro"
    }} showButtons={showCarouselNavigation} currentIndex={0} listItems={cards} />;
    $[19] = cards;
    $[20] = isMobile;
    $[21] = items.length;
    $[22] = showCarouselNavigation;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t9) {
    t10 = <section className={t7} ref={componentRef}>{t8}{t9}</section>;
    $[24] = t7;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
function mapStateToProps(state: RootState, ownProps: OwnProps): Props {
  const {
    items
  } = ownProps;
  return {
    ...ownProps,
    searchId: state.search?.id ?? '',
    rank: getRankFor(getRankedUrnForGeoboost(items), 'GeoboostItem', state.search, state.items)
  };
}
export { Geoboost };
export default connect<Props, void, OwnProps, RootState>(mapStateToProps)(Geoboost);
function _temp(ad) {
  if (!isInterstitialEnabled(ad)) {
    return {
      "data-google-interstitial": "false"
    };
  }
}